@use "~theme/typography";

.headline {
  border: none;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: var(--blue-03);
  margin: 10px 0px;
  height: 34px;
  color: var(--blue-01);
  letter-spacing: 0.12em;
  padding: 0 16px;
  box-sizing: border-box;
  column-gap: 8px;

  &::before {
    content: "";
    width: 20px;
    flex: 0 0 20px;
  }
}

.headlineTitle {
  @include typography.body-semibold;
  font-weight: 400;
  text-transform: capitalize;
  margin: 0;
  white-space: nowrap;
  text-align: center;
  flex: 1 1 auto;
  min-width: 0;
  padding: 0 4px;
}

.headlineIcon {
  padding: 0;
  margin-left: 0;
  width: 20px;
  flex: 0 0 20px;
  transition: transform 0.25s ease-out;
}

.headlineIconExpanded {
  transform: rotate(180deg);
}

.doctors > * {
  border-bottom: 1px solid var(--blue-01-at-30);
  padding: 24px 0;

  &:last-child {
    border: none;
    padding-bottom: 0;
  }
}
